import React from "react";
import Coursel from "../component/Courser";
import Header from "../component/header";
import "../stylesheets/home.css";
import "../stylesheets/projects.css";

const Home = () => {
  return (
    <>
      <div className="first-div">
        <Header />
        <div className="introduction flex-with-center">
          <div>
            <h1 data-aos="fade-up" className="name">
              Hello <br /> Im Alzubair
            </h1>
            <div className="intro-content d-flex justify-content-between">
              <p className="intro-p">
                FrontEnd developer, <br /> FullStack developer, Instructor
              </p>
              <a href="/contact" className="primary-button font-bold">
                Contact
              </a>
            </div>
            <div className="d-flex">
              <a href="/projects" className="w-100 primary-button font-bold">
                See My Projects
              </a>
            </div>
          </div>
        </div>
        <Coursel />
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#EBECF0"
            fill-opacity="1"
            d="M0,192L24,165.3C48,139,96,85,144,96C192,107,240,181,288,197.3C336,213,384,171,432,133.3C480,96,528,64,576,90.7C624,117,672,203,720,240C768,277,816,267,864,224C912,181,960,107,1008,69.3C1056,32,1104,32,1152,80C1200,128,1248,224,1296,250.7C1344,277,1392,235,1416,213.3L1440,192L1440,320L1416,320C1392,320,1344,320,1296,320C1248,320,1200,320,1152,320C1104,320,1056,320,1008,320C960,320,912,320,864,320C816,320,768,320,720,320C672,320,624,320,576,320C528,320,480,320,432,320C384,320,336,320,288,320C240,320,192,320,144,320C96,320,48,320,24,320L0,320Z"
          ></path>
        </svg>
      </div>
      <div className="container">
        <div className="row justify-content-start">
          <div className="col-md-4 py-4">
            <div data-aos="fade-right" className="n-box2 px-3 py-4 font-bold">
              <h1>Im Full-stack Developer...</h1>
              <p>In love with Front-end...</p>
            </div>
          </div>
        </div>

        <div className="row pt-5 justify-content-center">
          <div className="col-md-4">
            <div data-aos="fade-up">
              <img
                src="../hero-image-5.svg"
                alt="Js"
                height="300"
                className="home-pic w-200"
              />
            </div>
          </div>
        </div>

        <div className="row pt-5 justify-content-end">
          <div className="col-md-4">
            <div data-aos="fade-left" className="n-box2 px-3 py-4 font-bold">
              <p>Im in love with Front-End because its a beautiful art</p>
            </div>
          </div>
        </div>
      </div>

      <div className="devstack container my-5 n-box2 py-4">
        <div className="text-center">
          <h3 className="font-bold text-center">My Development Stack</h3>
          <img src="./sftck-mn-img01.png" height="300" width="300" alt="tech" />
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="font-bold text-start">
              <h3 className="font-bold">Front-End</h3>
              <hr />
              <p>HTML5/CSS3</p>
              <p>JavaScript</p>
              <p>React.js</p>
              <p>Redux</p>
              <p>Bootstrap</p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="font-bold text-center">
              <h3 className="font-bold">Intersted In</h3>
              <hr />
              <p>Python</p>
              <p>Machine Learning</p>
              <p>Deep Learning</p>
              <p>Data science</p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="font-bold text-end">
              <h3 className="font-bold">Back-End/DB</h3>
              <hr />
              <p>Ruby</p>
              <p>Node.js</p>
              <p>Ruby on Rails</p>
              <p>Mongo DB</p>
              <p>SQL DB</p>
            </div>
          </div>
        </div>
      </div>

      <div>
        <h3 className="font-bold text-center">Who is Zubair</h3>
        <div
          className="who-is-zubair flex-with-center"
          style={{ backgroundImage: `url('/blob-haikei.png')` }}
        >
          <div>
            <h3>Hi, Hello</h3>
            <hr />
            <p>
              <pre>
                {JSON.stringify(
                  {
                    Name: "Alzubair Khudhur abbas",
                    Age: "24",
                    Specialization: "Full Stack developer",
                    Care_about: "Programmin languages",
                  },
                  null,
                  2
                )}
              </pre>
            </p>
          </div>
        </div>
      </div>

      <dib className="about-me-container">
        <div className="about-me-section">
          <h1>Im Alzubair</h1>
          <p>
            Hello! I’m a Full-stack developer with a preferance for the
            Front-end side. I am proficient in Html5, css3, JavaScript React,
            Redux, API, and I used to work with express.js as well. As for the
            Back-end, I use Ruby and Rails. I use SQL database and Mongo
            Database. I Have a master’s degree in Information Technology-
            Computer Science.
          </p>
        </div>
      </dib>
    </>
  );
};

export default Home;
